<template>
    <div class="vert-center">
        <div class="wrapper">
                <div class="main-text-404">
                    <h1>We could not find what you are looking for.</h1>
                    <p>But wait! Don't just throw that question away!
                        <br>
                        Find out where it belongs by using the Waste Widget home page.
                    </p>
                    <router-link :to="{ path: '/' }" tag="button" class="button">Home</router-link>
                </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'notfoundpage',
    data() {
        return {}
    }
}
</script>

<style scoped>
    .center-text {
        width: 50%;
        margin: auto;
        margin-top: 30vh;
        text-align: center;
    }
    .back-text-404 {
        position: absolute;
        color: white;
        font-size: 400pt;
        opacity: .4;
        z-index: 1;
    }
    .main-text-404 {
        z-index: 2;
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align:center;
    }

    .wrapper {
        position: relative;
        padding-bottom: 100%;
        height: 0;
        background-image: url('~@/assets/images/404-75.png');
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        width: 50vw;
    }

    .inner-wrap {
        position: absolute;
        height: auto;
        bottom: 0;
        top: 0;
        right: 0;
        left: 0;
      
    }
    
    .vert-center{
        z-index: 1;
    }

    p{
        font-size: 2rem;
    }

    button{
        width: 15rem;
        text-align: center;
        font-size: 1.25rem;
        margin: 0 auto;
        text-transform: capitalize;
    }

    button a{
        color: #fff;
    }

    @media (max-width: 768px){
        .wrapper{
            width: 90vw;
        }
    }

</style>